import { authRouteConfig } from './auth';
import { initialUrl } from 'shared/constants/AppConst';
import { Navigate } from 'react-router-dom';
import Error403 from './errorPages/Error403';
import React from 'react';
import { errorPagesConfigs } from './errorPages';
import { samplePagesConfigs } from './sample';
import { accountPagesConfigs } from './account';
import { kebijakanPagesConfig } from './kebijakan';
import { framePagesConfg } from './appFrame';
import { dashboardPageConfig } from './dashboard';
import { dashPageConfig } from './tableuDashboard';
import { dashMstrPageConfig } from './mstrDashboard';
import { preparingSharingConfig } from './apps/PreparingSharing';
import { groupCalendarConfig } from './apps/GroupCalendar';
import { taskManagementConfig } from './apps/TaskManagement';
import { knowlegeManagementConfig } from './apps/KnowledgeManagement';
import { myPostConfig } from './apps/MyPost';
import { driveConfig } from './apps/Drive';
import { admintoolsConfig } from './apps/Admintools';
import { eventManagementConfig } from './apps/EventManagement';
import { userRolePagesConfig } from './apps/UserRole';
import { profilePageConfig } from './profile';
import { chatConfig } from './apps/Chat/ChatConfig';
import { surveyAppConfig } from './survey';
import { informationConfig } from './apps/Information';
import { kalenderPersonalConfig } from './apps/KalenderPersonal';
import { presensiConfig } from './apps/Presensi';
import { faqConfig } from './apps/Faq';
import { kepegawaianConfig } from './apps/Kepegawaian';
import { kalenderSatkerConfig } from './apps/KalenderSatker';
import { produkHukumConfig } from './apps/ProdukHukum';
import { notulensiConfigs } from './apps/Notulensi';
import { programKerjaConfigs } from './programKerja';
import { bpkDriveConfigs } from './apps/BPKDrive';
import { newbpkDriveConfigs } from './apps/NewBPKDrive';

const authorizedStructure = {
  fallbackPath: '/redirect',
  unAuthorizedComponent: <Error403 />,
  routes: [
    ...samplePagesConfigs,
    ...faqConfig,
    ...accountPagesConfigs,
    ...framePagesConfg,
    ...dashboardPageConfig,
    ...dashPageConfig,
    ...dashMstrPageConfig,
    ...preparingSharingConfig,
    ...admintoolsConfig,
    ...groupCalendarConfig,
    ...knowlegeManagementConfig,
    ...kebijakanPagesConfig,
    ...myPostConfig,
    ...taskManagementConfig,
    ...driveConfig,
    ...informationConfig,
    ...eventManagementConfig,
    ...userRolePagesConfig,
    ...profilePageConfig,
    ...chatConfig,
    ...surveyAppConfig,
    ...kalenderPersonalConfig,
    ...presensiConfig,
    ...kepegawaianConfig,
    ...kalenderSatkerConfig,
    ...produkHukumConfig,
    ...notulensiConfigs,
    ...programKerjaConfigs,
    ...bpkDriveConfigs,
    ...newbpkDriveConfigs
  ],
};

const unAuthorizedStructure = {
  fallbackPath: window.location.pathname,
  routes: authRouteConfig,
};

const anonymousStructure = {
  routes: errorPagesConfigs.concat([
    {
      path: '/',
      element: <Navigate to={initialUrl} />,
    },
    {
      path: '*',
      element: <Navigate to='/error-pages/error-404' />,
    },
  ]),
};
if (window.location.href.endsWith("/redirect")) {
  //redirect manually → redirect to "/"
  window.location.replace("/kkp");
}
export { authorizedStructure, unAuthorizedStructure, anonymousStructure };
